<template>
	<router-link :to="link" class="router-link">
		<button @click="clickHandler" :style="buttonStyle" class="custom-button">
			{{ text }}
		</button>
	</router-link>
</template>

<script>
export default {
	name: "ReadMoreButton",
	props: {
		text: {
			type: String,
			default: "Read More",
		},
		backgroundColor: {
			type: String,
			default: "#424EC4",
		},
		width: {
			type: String,
			default: "147px",
		},
		height: {
			type: String,
			default: "44px",
		},
		color: {
			type: String,
			default: "#fff",
		},
		link: {
			type: [String, Object],
			required: true,
		},
		clickHandler: {
			type: Function,
			default: () => {},
		}
	},
	computed: {
		buttonStyle() {
			return {
				backgroundColor: ` ${this.backgroundColor} `,
				width: this.width,
				height: this.height,
				color: this.color,
				border: "none",
				display: "inline-block",
				textAlign: "center",
				cursor: "pointer",
				fontSize: "14px",
				fontWeight: "bold",
				transition: "opacity 0.3s ease",
				padding: "10px 20px 10px 20px",
				gap: "0px",
				borderRadius: "50px",
			};
		},
		displayText() {
			return this.text || "Read More";
		},
	},
};
</script>

<style scoped>
.custom-button:hover {
	opacity: 0.9;
}
.router-link {
	text-decoration: none;
}
</style>
